"use client";

import { Amplify } from "aws-amplify";
import awsconfig from "../../../../configs/amplifyconfiguration";
Amplify.configure(awsconfig, { ssr: true });

import { ClearProjectCookies } from "@packages/lib/utlils/logout";
export default function User({ topnav_data }: any) {
  const userprofile =
    topnav_data?.data?.contentData?.items[0]?.customerProfileMenu
      ?.navChildC1Collection?.items;
  return (
    <>
      <div className="flex justify-between p-[16px] absolute z-[99] top-[56px] right-[-39px] shadow-custom-5 bg-white min-w-[339px] rounded-[4px] md:top-[65px] lg:top-[62px] lg:right-0">
        <ul className="small">
          {userprofile?.map((item: any, index: any) => (
            <li
              key={index}
              className={
                item?.navTitle === "Logout"
                  ? `text-primary-400 hover:underline`
                  : "mb-[16px] hover:underline"
              }
            >
              <a
                href={item?.navUrl || ""}
                className="font-normal small"
                onClick={(e) => {
                  if (item?.navTitle?.toLowerCase() === "logout") {
                    e.preventDefault();
                    ClearProjectCookies();
                  }
                }}
              >
                {item?.navTitle}
              </a>
            </li>
          ))}
        </ul>
        <a
          href="#"
          className="font-semibold x-small text-success-700 uppercase tracking-[1px] self-start"
        >
          Complete your profile
        </a>
      </div>
    </>
  );
}
